import * as React from "react";
import { ErrorBoundary } from "react-error-boundary";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { Box } from "@mui/material";
import ErrorFallback from "./errors/error-fallback";
import logger from "../utils/logger";
import Footer from "../components/footer/footer";
import NavbarBreadcrumbs from "../components/breadcrumbs/navbar-breadcrumbs";

export interface PageProps {
  children: React.ReactNode;
  withFooter?: boolean;
}

const Page = ({ children, withFooter = true }: PageProps) => {
  const navigate = useNavigate();
  const handleError = (error: Error) => logger.error(error);

  return (
    <>
      <Helmet>
        <title>Keoghs Dtection - Dashboard</title>
      </Helmet>
      <ErrorBoundary
        FallbackComponent={ErrorFallback}
        onReset={() => navigate("/")}
        onError={handleError}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            width: "100%",
          }}
        >
          <Box
            width="100%"
            sx={{
              flexGrow: 1,
              maxWidth: { sm: "90%", md: "1200px", lg: "1700px" },
              padding: "30px",
              paddingTop: "10px",
              paddingBottom: 0,
            }}
          >
            <NavbarBreadcrumbs />
            {children}
          </Box>
        </Box>
      </ErrorBoundary>
      {withFooter ?? <Footer />}
    </>
  );
};

export default Page;
